import { render, staticRenderFns } from "./hidden_badge.vue?vue&type=template&id=c8ecab3e"
import script from "./hidden_badge.vue?vue&type=script&lang=js"
export * from "./hidden_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports